export const numberToPercent = (number) => {
  return parseFloat((number - 1) * 100).toFixed(2);
};
